import { useEffect, useRef } from 'react';
import { usePicoXTrack } from '@eventbrite/bsp-sdk/react';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { buildPicoXListingsPageViewPayload, LISTINGS_PAGE_VIEW_EVENT_NAME } from '@/src/listings/tracking';
import { getTrackedPagePath } from '@/src/listings/utils/pageViewPath';

type UseListingsPageViewPicoXTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  isPreview: boolean | undefined;
};

export function useListingsPageViewPicoXTrackingEffect({
  pageContext,
  isPreview,
}: UseListingsPageViewPicoXTrackingEffectArgs) {
  const trackPicoXEvent = usePicoXTrack();
  const pageViewTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    const eventId = pageContext?.basicInfo?.id;

    if (isPreview || !eventId) {
      return;
    }

    if (pageViewTrackedEventIdRef.current === eventId) {
      return;
    }

    pageViewTrackedEventIdRef.current = eventId;
    trackPicoXEvent(
      LISTINGS_PAGE_VIEW_EVENT_NAME,
      buildPicoXListingsPageViewPayload({ eventId, path: getTrackedPagePath() }),
    );
  }, [pageContext, isPreview, trackPicoXEvent]);
}
